<template>
    <div class="policy-entry">
      <Card>
        <v-row class="ma-0 py-4 py-md-7">
          <v-col class="col-12 pa-0">
            <List head headTitle1="标题" headTitle2="发布时间" :list="list[skip]" :loading="loading" @clickItem="itemOnClick">
            </List>
            <v-pagination
              class="pagination align-self-center align-self-md-end mb-4 mr-5"
              v-if="pagination"
              :value="skip + 1"
              :length="paginationLength"
              :total-visible="7"
              color="primary"
              @input="input"
          ></v-pagination>
          </v-col>
        </v-row>
      </Card>
    </div>

</template>

<script>
import { Card, List } from '@/components/UI'
import { Policy } from '@/mixins/policy'
export default {
  name: 'PolicyEntry',
  mixins: [Policy],
  components: {
    Card,
    List
  },
  async mounted () {
    await this.getPolicy()
  }
}
</script>

<style lang="scss" scoped>
</style>
